﻿let $ = require('jQuery');
let eventRepository = require('../eventRepository');
let moment = require('moment');
let _ = require('lodash');
require('../fullcalendar.min.js');

module.exports = EventsCalendar;

const NationalRegion = 'National';

function EventsCalendar(element) {
    let region = null;

    element.fullCalendar({
        header: {
            left: 'prev',
            center: 'title',
            right: 'next'
        },
        buttonIcons: {
            prev: 'prev',
            next: 'next'
        },
        eventLimit: 1,
        eventLimitClick : () => {},

        events: function (start, end, timezone, callback) {
            let date = this.getDate();

            let month = date.month() + 1;
            let year = date.year();

            eventRepository.getEventsForMonth(year, month)
                .then(events => filterEventsByRegion(events, region))
                .then(events => events.map(mapEventToCalendarEvent))
                .then(events => callback(events))
                .then(eventRepository.getEventsForMonth(year, month + 1)) //preload next month events
                .done();
        },

        dayClick: function (date) {
            let observers = window.dateSelectedObservers || [];
            observers.forEach(observer => observer.notify(date));
        }
    });

    $(document).on('regionsFilterChange', (event, params) => {
        region = params.regionName;
        element.fullCalendar('refetchEvents');
    });

}

function mapEventToCalendarEvent(event) {
    return {
        title: event.Name,
        start: moment(event.StartDate),
        end: moment(event.EndDate)
    };
}

function filterEventsByRegion(events, region) {
    return region ? _.filter(events, event => event.Region === NationalRegion || event.Region === region) : events;
}